// extracted by mini-css-extract-plugin
module.exports = {"main":"user-form_main__m3HCj","form":"user-form_form__2ISHO","link":"user-form_link__3nsrZ"};